import React, { useMemo } from "react";
import { Col, Dropdown, Form, Row } from "react-bootstrap";
import { langTypeMap } from "../../../../../../shared/Data/langTypeMap";
import { genId } from "../../../../../../shared/utils";

export function AddItemForm({
  name,
  newCatState,
  setNewCatState,
  parentKey,
  itemParent,
  setItemParent,
  source
}) {
  const formSchema = useMemo(() => {
    return langTypeMap[name].getFormSchema((opts) => opts.map(opt => <option key={opt} value={opt}>{opt}</option>))
    // return langTypeMap[name].getFormSchema()
  }, [name])

  const parentControl = useMemo(() => (
    parentKey ? (
      <Row>
        <Form.Label column sm={4}>
          Adding to Parent ({parentKey}):
        </Form.Label>
        <Col sm={8}>
          <Dropdown onSelect={(val, evt) => setItemParent(val)}>
            <Dropdown.Toggle>{itemParent && source[parentKey].find(itm => itm._id === itemParent).getDisplayText()}</Dropdown.Toggle>
            <Dropdown.Menu className="lang-editor-multiselect-add-item-drop" >
              {source[parentKey].map((itm, idx) => (<Dropdown.Item key={idx} eventKey={itm._id}>{itm.getDisplayText()}</Dropdown.Item>))}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>

    ) : []
  ), [parentKey, itemParent, setItemParent, source])
  return (
    <Form>
      {parentControl}

      {formSchema.map((i, idx) => {
        return (
          <Form.Group key={idx}>
            <Form.Label column sm={2}>{i.name}</Form.Label>
            <Col>
              <Form.Control
                id={i.name}
                {...i}
                value={newCatState[i.name]}
                onChange={(evt) =>
                  setNewCatState({ ...newCatState, [i.name]: evt.target.value, rel_id: newCatState.rel_id || genId() })
                } />
            </Col>
          </Form.Group>
        )
      })}
    </Form>
  )
}